import { Action, createReducer, on } from '@ngrx/store';

import {
  fetchAirValidationSuccessAction,
  fetchAirValidationBySectorSuccessAction,
  fetchAutoValidationSuccessAction,
  fetchHotelValidationSuccessAction,
  fetchPackageValidationSuccessAction
} from '@booking/store/actions/booking.actions';

export const initialState = false;

export const reducer = createReducer(
  initialState,
  on(
    fetchAirValidationSuccessAction,
    fetchAirValidationBySectorSuccessAction,
    fetchHotelValidationSuccessAction,
    fetchAutoValidationSuccessAction,
    fetchPackageValidationSuccessAction,
    (state) => true
  ),
);

export const isTokenAuthenticateReducer = (state: boolean, action: Action): boolean => {
  return reducer(state, action);
};

